export const GET_INDUSTRIES_AUTOCOMPLETE_ERROR = 'Failed to fetch industries autocomplete from perseus.';
